var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex lg:flex-row lg:justify-between flex-col gap-2" },
        [
          _c(
            "div",
            {
              staticClass:
                "flex gap-2 text-primary items-center justify-between",
            },
            [
              _c(
                "div",
                { staticClass: "flex gap-2 text-primary items-center" },
                [
                  _c("v-icon", { attrs: { color: "primary", size: 20 } }, [
                    _vm._v(" mdi-human-capacity-decrease "),
                  ]),
                  _c("span", { staticClass: "text-xl font-medium" }, [
                    _vm._v(_vm._s(_vm.$t("agent.header"))),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex justify-end" },
                [
                  _vm.tab === "manage" && !_vm.selected
                    ? _c("tier-create", {
                        on: {
                          submit: function ($event) {
                            return _vm.tierRefetch()
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _vm.tab === "agent"
            ? _c(
                "div",
                {
                  staticClass:
                    "flex gap-2 flex-col sm:flex-row lg:flex justify-between lg:justify-end overflow-auto",
                },
                [
                  _c("agent-remove-list"),
                  _c("agent-create", {
                    on: {
                      submit: function ($event) {
                        return _vm.resellerRefetch()
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "v-tabs",
        {
          staticClass: "app-tab mt-6",
          attrs: { "show-arrows": "" },
          on: {
            change: function ($event) {
              return _vm.deselect()
            },
          },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        _vm._l(_vm.tabHeaders, function (header) {
          return _c(
            "v-tab",
            { key: header.id, attrs: { href: `#${header.value}` } },
            [_vm._v(" " + _vm._s(header.title) + " ")]
          )
        }),
        1
      ),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(
            "v-tab-item",
            { attrs: { value: "manage" } },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c(
                    "v-card-text",
                    [
                      !_vm.selected
                        ? [
                            this.$vuetify.breakpoint.smAndUp
                              ? _c("title-label", {
                                  staticClass: "mb-4",
                                  attrs: { label: _vm.$t("agent.tier.title") },
                                })
                              : _vm._e(),
                            _c("tier-data-table", {
                              ref: "TierDataTable",
                              on: {
                                selected: function ($event) {
                                  return _vm.select($event)
                                },
                              },
                            }),
                          ]
                        : _c("tier-product-data-table", {
                            ref: "TierProductDataTable",
                            attrs: { "item-tier-id": _vm.selected.id },
                            on: {
                              close: function ($event) {
                                return _vm.deselect()
                              },
                            },
                          }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-tab-item",
            { attrs: { value: "agent" } },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex sm:justify-between flex-col sm:flex-row sm:items-center mb-4",
                        },
                        [
                          _c("title-label", {
                            attrs: { label: _vm.$t("agent.agent.title") },
                          }),
                          _c("v-spacer"),
                          _c(
                            "div",
                            { staticClass: "flex-grow-1" },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "mdi-magnify",
                                  placeholder: _vm.$t(
                                    "app.form.search.placeholder"
                                  ),
                                  dense: "",
                                  "hide-details": "",
                                  outlined: "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.search($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("agent-data-table", {
                        ref: "ResellerDataTable",
                        attrs: { q: _vm.resellerQuery },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-tab-item",
            { attrs: { value: "setting" } },
            [_c("option-form")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }